import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

import {
  IPublicClientApplication,
  PublicClientApplication,
  LogLevel,
  InteractionType
} from '@azure/msal-browser';

import {
  MsalInterceptor,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
export const apiScope = `${environment.apiScope}`;
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalClientId,
      authority: environment.msalAuthority,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.redirectUri
      // navigateToLoginRequestUrl: removed — not supported in msal-browser v5
    },
    cache: {
      cacheLocation: 'sessionStorage'
      // storeAuthStateInCookie: removed — not supported in msal-browser v5
    },
    system: {
      // allowNativeBroker: removed — not supported in msal-browser v5
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          console.log(message);
        },
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // Protect YOUR API so MSAL attaches a bearer token to those calls.
  // protectedResourceMap.set(`${environment.apiUrl}/*`, ['user.read']);
  // protectedResourceMap.set('http://localhost:8000/*', ['user.read']);

  const API_SCOPE = environment.apiScope;

  protectedResourceMap.set(
    `${environment.apiUrl}/*`,
    [API_SCOPE]
  );

  protectedResourceMap.set(
    'http://localhost:8000/*',
    [API_SCOPE]
  );

  

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: [environment.apiScope] }
  };
}

export function initializeMsal(msalService: MsalService) {
  return () =>
    msalService.instance.initialize().then(() =>
      msalService.instance.handleRedirectPromise().then((result) => {
        if (result?.account) {
          msalService.instance.setActiveAccount(result.account);
        } else {
          // On a normal reload there is no redirect result; recover the
          // account from the cache so the header can read it.
          const accounts = msalService.instance.getAllAccounts();
          if (accounts.length > 0) {
            msalService.instance.setActiveAccount(accounts[0]);
          }
        }
      })
    );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // withInterceptorsFromDi() is REQUIRED so the class-based
    // MsalInterceptor registered below actually runs.
    provideHttpClient(withInterceptorsFromDi()),

    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },

    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [MsalService],
      multi: true
    },

    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]
};